Astro.video = function() {
    document.querySelectorAll('.block__video').forEach(function(element, i) {
        var videoBlock = new VideoBlock(element);
        videoBlock.init();
    });
}
